import { render, staticRenderFns } from "./x-video-list.vue?vue&type=template&id=1d619dfa&scoped=true"
import script from "./x-video-list.vue?vue&type=script&lang=js"
export * from "./x-video-list.vue?vue&type=script&lang=js"
import style0 from "./x-video-list.vue?vue&type=style&index=0&id=1d619dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d619dfa",
  null
  
)

export default component.exports